var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemebership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.58275 8.70862H21.4172M6.34935 16.2424H8.2328M10.5876 16.2424H14.3545M6.76401 4H17.2266C20.5791 4 21.4172 4.82872 21.4172 8.13417V15.8657C21.4172 19.1712 20.5791 19.9999 17.236 19.9999H6.76401C3.42088 20.0093 2.58275 19.1806 2.58275 15.8752V8.13417C2.58275 4.82872 3.42088 4 6.76401 4Z",
    stroke: "#0B0A0A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemebership);
export default __webpack_public_path__ + "static/media/memebership.76af22ff4412d56fd42b9ec7ee18f3e6.svg";
export { ForwardRef as ReactComponent };